.group > *:focus-visible {
  position: relative;
  z-index: var(--dds-zindex-absolute-element);
}

.group--column {
  display: flex;
  flex-direction: column;

  > * {
    width: 100%;
  }
}

.group--column > *:first-child {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-block-end: -1px;
}

.group--column > *:last-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.group--column > *:not(:first-child):not(:last-child) {
  border-radius: 0;
  margin-block-end: -1px;
}

.group--row > *:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin-inline-end: -1px;
}

.group--row > *:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.group--row > *:not(:first-child):not(:last-child) {
  border-radius: 0;
  margin-inline-end: -1px;
}
